<app-formulario  URL="tramite-titulo" titulo="Nuevo Titulo Electronico"></app-formulario>
<app-sistema-menu></app-sistema-menu>

<div class="contenedor columns " style="height:100%; padding:0px;">

    <div class="column is-2 is-hidden-mobile menu-izquierda">
        <app-sistema-menu-aside></app-sistema-menu-aside>
    </div>


    <div class="tramite-container" style="padding:0px;">

        <!-- Overlay de carga -->
        <div *ngIf="showLoadingOverlay" class="loading-overlay">
            <div class="loading-content">
            <div class="loading-spinner">
                <i class="fas fa-spinner fa-spin fa-3x"></i>
            </div>
            <div class="loading-text">
                <p>Trabajando, por favor espere...</p>
            </div>
            </div>
        </div>

        <!-- Barra superior fija con color amarillo/dorado -->
        <!--<div class="top-bar" *ngIf="!showProfesionistaModal">
            <div class="level">
                <div class="level-left">
                    <div class="title-container">
                    <span class="icon">
                        <i class="fas fa-graduation-cap"></i>
                    </span>
                    <h1 class="title is-4">Nuevo Trámite de Título</h1>
                    </div>
                </div>
                <div class="level-right">
                    <button 
                    class="button is-primary is-medium" 
                    [class.is-loading]="isLoading"
                    (click)="onSubmit()"
                    type="button"
                    [disabled]="isLoading">
                    <span class="icon">
                        <i class="fas fa-save"></i>
                    </span>
                    <span>Guardar Trámite</span>
                    </button>
                </div>
            </div>
        </div>-->

        <div class="card-container">
            <div class="card top-card has-background-primary" *ngIf="!showProfesionistaModal">
                <div class="card-content">
                <div class="level">
                    <div class="level-left">
                    <div class="title-container">
                        <span class="icon has-text-white">
                        <i class="fas fa-graduation-cap"></i>
                        </span>
                        <h1 class="title is-4 has-text-white">Nuevo Trámite de Título</h1>
                    </div>
                    </div>
                    <div class="level-right">
                    <button 
                        class="button is-success is-medium has-text-white" 
                        [class.is-loading]="isLoading"
                        (click)="onSubmit()"
                        type="button"
                        [disabled]="isLoading">
                        <span class="icon">
                        <i class="fas fa-save"></i>
                        </span>
                        <span>Guardar Trámite</span>
                    </button>
                    </div>
                </div>
                </div>
            </div>
        </div>

        <!-- Contenido con scroll -->
        <div class="content-scrollable" [class.content-blur]="showProfesionistaModal" style="background-color: #f5f5f0; padding:10px;">
            
            <div style="background-color: #EEF2F8; padding: 10px; padding-bottom: 2rem;">

            <!-- Mensajes de alerta -->
            <div *ngIf="errorMessage" class="notification is-danger is-light">
                <button class="delete" (click)="errorMessage = ''"></button>
                {{ errorMessage }}
            </div>

            <div *ngIf="successMessage" class="notification is-success is-light">
                <button class="delete" (click)="successMessage = ''"></button>
                {{ successMessage }}
            </div>

            <form [formGroup]="tramiteForm">
                
                <!-- Card: TituloElectronico -->
                <div class="card mb-4" >
                <div class="card-header">
                    <h2 class="card-header-title">Información del Título Electrónico</h2>
                    <span class="icon" [class.has-text-danger]="!isCardValid('tituloElectronico')" [class.has-text-success]="isCardValid('tituloElectronico')">
                      <i class="fas fa-lg" [class.fa-exclamation-triangle]="!isCardValid('tituloElectronico')" [class.fa-check-circle]="isCardValid('tituloElectronico')"></i>
                    </span>
                </div>
                <div class="card-content">
                    <div class="columns is-multiline">
                    <div class="column is-6">
                        <div class="field">
                        <label class="label">Versión</label>
                        <div class="control">
                            <input 
                            class="input" 
                            type="text" 
                            step="0.1" 
                            readonly
                            formControlName="version"
                            [class.is-danger]="isFieldInvalid('version')">
                        </div>
                        <p *ngIf="isFieldInvalid('version')" class="help is-danger">
                            Versión requerida
                        </p>
                        </div>
                    </div>
                    <div class="column is-6">
                        <div class="field">
                        <label class="label">Folio Control</label>
                        <div class="control">
                            <input 
                            class="input" 
                            type="text" 
                            formControlName="folioControl"
                            [class.is-danger]="isFieldInvalid('folioControl')">
                        </div>
                        <p *ngIf="isFieldInvalid('folioControl')" class="help is-danger">
                            Folio control requerido (máx. 55 caracteres)
                        </p>
                        </div>
                    </div>
                    </div>
                </div>
                </div>



                <!-- Card: Institucion -->
                <div class="card mb-4">
                <div class="card-header">
                    <h2 class="card-header-title">Institución</h2>
                    <span class="icon " [class.has-text-danger]="!isCardValid('institucion')" [class.has-text-success]="isCardValid('institucion')">
                      <i class="fas fa-lg" [class.fa-exclamation-triangle]="!isCardValid('institucion')" [class.fa-check-circle]="isCardValid('institucion')"></i>
                    </span>
                </div>
                <div class="card-content">
                    <div class="columns is-multiline">
                    <div class="column is-6">
                        <div class="field">
                        <label class="label">Clave Institución</label>
                        <div class="control">
                            <input 
                            class="input" 
                            type="number" 
                            value="070413"
                            readonly
                            formControlName="cveInstitucion"
                            [class.is-danger]="isFieldInvalid('cveInstitucion')">
                        </div>
                        </div>
                    </div>
                    <div class="column is-6">
                        <div class="field">
                        <label class="label">Nombre Institución</label>
                        <div class="control">
                            <input 
                            class="input" 
                            type="text"
                            value="INSTITUTO EN CIENCIAS DE LA SALUD Y MEDICINA INTEGRAL SAMUEL HAHNEMANN" 
                            readonly
                            formControlName="nombreInstitucion"
                            [class.is-danger]="isFieldInvalid('nombreInstitucion')">
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
                </div>


                                <!-- Card: Profesionista -->
                <div class="card mb-4">
                <div class="card-header">
                    <h2 class="card-header-title">Profesionista</h2>
                    <span class="icon is-medium" [class.has-text-danger]="!isCardValid('profesionista')" [class.has-text-success]="isCardValid('profesionista')">
                      <i class="fas fa-lg" [class.fa-exclamation-triangle]="!isCardValid('profesionista')" [class.fa-check-circle]="isCardValid('profesionista')"></i>
                    </span>
                </div>
                <div class="card-content">
                    <!-- Nueva fila: Búsqueda de profesionista -->
                    <div class="columns is-multiline">
                    <div class="column is-12">
                        <div class="field">
                        <label class="label">Buscar Profesionista</label>
                        <div class="field has-addons">
                            <div class="control is-expanded">
                            <input 
                                class="input" 
                                type="text" 
                                id="profesionista_buscar"
                                name="profesionista_buscar"
                                formControlName="profesionista_buscar"
                                placeholder="Ingrese nombre, matrícula o CURP">
                            </div>
                            <div class="control">
                            <button 
                                class="button is-primary" 
                                type="button"
                                (click)="buscarProfesionista()"
                                [disabled]="isLoading">
                                <span class="icon">
                                <i class="fas fa-search"></i>
                                </span>
                                <span>Buscar</span>
                            </button>
                            </div>
                        </div>
                        </div>
                    </div>
                    </div>

                    <div class="columns is-multiline">
                    
                    <div class="column is-4">
                        <div class="field">
                        <label class="label">Nombre</label>
                        <div class="control">
                            <input 
                            class="input" 
                            type="text" 
                            formControlName="nombreProfesionista"
                            readonly
                            [class.is-danger]="isFieldInvalid('nombreProfesionista')">
                        </div>
                        </div>
                    </div>
                    <div class="column is-4">
                        <div class="field">
                        <label class="label">Primer Apellido</label>
                        <div class="control">
                            <input 
                            class="input" 
                            type="text" 
                            formControlName="primerApellidoProfesionista"
                            readonly
                            [class.is-danger]="isFieldInvalid('primerApellidoProfesionista')">
                        </div>
                        </div>
                    </div>
                    <div class="column is-4">
                        <div class="field">
                            <label class="label">Segundo Apellido</label>
                            <div class="control">
                                <input 
                                class="input" 
                                type="text" 
                                formControlName="segundoApellidoProfesionista"
                                readonly>
                            </div>
                        </div>
                    </div>

                    <div class="column is-4">
                        <div class="field">
                        <label class="label">CURP Profesionista</label>
                        <div class="control">
                            <input 
                            class="input" 
                            type="text" 
                            formControlName="curpProfesionista"
                            readonly
                            [class.is-danger]="isFieldInvalid('curpProfesionista')">
                        </div>
                        </div>
                    </div>
                    <div class="column is-8">
                        <div class="field">
                            <label class="label">Correo Electrónico</label>
                            <div class="control">
                                <input 
                                class="input" 
                                type="email" 
                                formControlName="correoElectronico"
                                readonly
                                [class.is-danger]="isFieldInvalid('correoElectronico')">
                            </div>
                        </div>
                    </div>


                    </div>
                </div>
                </div>


                <!-- Card: Carrera -->
                <div class="card mb-4">
                <div class="card-header">
                    <h2 class="card-header-title">Carrera</h2>
                    <span class="icon is-medium" [class.has-text-danger]="!isCardValid('carrera')" [class.has-text-success]="isCardValid('carrera')">
                      <i class="fas fa-lg" [class.fa-exclamation-triangle]="!isCardValid('carrera')" [class.fa-check-circle]="isCardValid('carrera')"></i>
                    </span>
                </div>
                <div class="card-content">
                    <div class="columns is-multiline">
                    <div class="column is-4">
                        <div class="field">
                        <label class="label">Clave Carrera</label>
                        <div class="control">
                            <input 
                            class="input" 
                            type="number"
                            readonly 
                            formControlName="cveCarrera"
                            [class.is-danger]="isFieldInvalid('cveCarrera')">
                        </div>
                        </div>
                    </div>
                    <div class="column is-8">
                        <div class="field">
                        <label class="label">Nombre Carrera</label>
                        <div class="control">
                            <input 
                            class="input" 
                            type="text"
                            readonly 
                            formControlName="nombreCarrera"
                            [class.is-danger]="isFieldInvalid('nombreCarrera')">
                        </div>
                        </div>
                    </div>

                    <div class="column is-4">
                        <div class="field">
                        <label class="label">Número RVOE</label>
                            <div class="control">
                                <input 
                                class="input" 
                                type="number"
                                readonly 
                                formControlName="numeroRvoe">
                            </div>
                        </div>
                    </div>
                    
                    <div class="column is-4">
                        <div class="field">
                        <label class="label">ID Autorización Reconocimiento</label>
                        <div class="control">
                            <div class="select is-fullwidth">
                            <select 
                                formControlName="idAutorizacionReconocimiento"
                                (change)="onAutorizacionReconocimientoChange($event)"
                                [class.is-danger]="isFieldInvalid('idAutorizacionReconocimiento')">
                                <option value="">Seleccione una autorización</option>
                                <option *ngFor="let autorizacion of autorizacionesReconocimiento" [value]="autorizacion.id">
                                {{ autorizacion.id }} - {{ autorizacion.nombre }}
                                </option>
                            </select>
                            </div>
                        </div>
                        <p *ngIf="isFieldInvalid('idAutorizacionReconocimiento')" class="help is-danger">
                            Autorización de reconocimiento requerida
                        </p>
                        </div>
                    </div>
                    <div class="column is-4">
                        <div class="field">
                        <label class="label">Autorización Reconocimiento</label>
                        <div class="control">
                            <input 
                            class="input" 
                            type="text" 
                            formControlName="autorizacionReconocimiento"
                            readonly
                            [class.is-danger]="isFieldInvalid('autorizacionReconocimiento')">
                        </div>
                        <p *ngIf="isFieldInvalid('autorizacionReconocimiento')" class="help is-danger">
                            Autorización de reconocimiento requerida
                        </p>
                        </div>
                    </div>

                    

                    <div class="column is-4">
                        <div class="field">
                        <label class="label">Fecha Inicio Carrera</label>
                        <div class="control">
                            <input 
                            class="input" 
                            type="date" 
                            formControlName="fechaInicioCarrera">
                        </div>
                        </div>
                    </div>
                    <div class="column is-4">
                        <div class="field">
                        <label class="label">Fecha Terminación Carrera *</label>
                            <div class="control">
                                <input 
                                class="input" 
                                type="date" 
                                formControlName="fechaTerminacionCarrera"
                                [class.is-danger]="isFieldInvalid('fechaTerminacionCarrera')">
                            </div>
                        </div>
                    </div>




                    </div>
                </div>
                </div>



                <!-- Card: Expedicion -->
                <div class="card mb-4">
                <div class="card-header">
                    <h2 class="card-header-title">Expedición</h2>
                    <span class="icon is-medium" [class.has-text-danger]="!isCardValid('expedicion')" [class.has-text-success]="isCardValid('expedicion')">
                      <i class="fas fa-lg" [class.fa-exclamation-triangle]="!isCardValid('expedicion')" [class.fa-check-circle]="isCardValid('expedicion')"></i>
                    </span>
                </div>
                <div class="card-content">
                    <div class="columns is-multiline">
                    <div class="column is-3">
                        <div class="field">
                        <label class="label">Fecha Expedición *</label>
                        <div class="control">
                            <input 
                            class="input" 
                            type="date" 
                            formControlName="fechaExpedicion"
                            [class.is-danger]="isFieldInvalid('fechaExpedicion')">
                        </div>
                        </div>
                    </div>
                    <div class="column is-3">
                        <div class="field">
                        <label class="label">ID Modalidad Titulación</label>
                        <div class="control">
                            <div class="select is-fullwidth">
                            <select 
                                formControlName="idModalidadTitulacion"
                                (change)="onModalidadTitulacionChange($event)"
                                [class.is-danger]="isFieldInvalid('idModalidadTitulacion')">
                                <option value="">Seleccione una modalidad</option>
                                <option *ngFor="let modalidad of modalidadesTitulacion" [value]="modalidad.id">
                                {{ modalidad.id }} - {{ modalidad.nombre }}
                                </option>
                            </select>
                            </div>
                        </div>
                        <p *ngIf="isFieldInvalid('idModalidadTitulacion')" class="help is-danger">
                            Modalidad de titulación requerida
                        </p>
                        </div>
                    </div>
                    <div class="column is-3">
                        <div class="field">
                        <label class="label">Modalidad Titulación</label>
                        <div class="control">
                            <input 
                            class="input" 
                            type="text" 
                            formControlName="modalidadTitulacion"
                            readonly
                            [class.is-danger]="isFieldInvalid('modalidadTitulacion')">
                        </div>
                        <p *ngIf="isFieldInvalid('modalidadTitulacion')" class="help is-danger">
                            Modalidad de titulación requerida
                        </p>
                        </div>
                    </div>

                    <!--<div class="column is-3">
                        <div class="field">
                        <label class="label">Cumplió Servicio Social</label>
                        <div class="control">
                            <input 
                            class="input" 
                            type="text" 
                            formControlName="cumplioServicioSocial"
                            [class.is-danger]="isFieldInvalid('cumplioServicioSocial')">
                        </div>
                        </div>
                    </div>-->


                    <div class="column is-3">
                        <div class="field">
                        <label class="label">Cumplió Servicio Social</label>
                        <div class="control">
                            <div class="select is-fullwidth">
                            <select 
                                formControlName="cumplioServicioSocial"
                                [class.is-danger]="isFieldInvalid('cumplioServicioSocial')"
                                readonly>
                                <option value="">Seleccione una opcion</option>
                                <option *ngFor="let servicio of serviciosSociales" [value]="servicio.id">
                                {{ servicio.nombre }}
                                </option>
                            </select>
                            </div>
                        </div>
                        <p *ngIf="isFieldInvalid('cumplioServicioSocial')" class="help is-danger">
                            Opcion requerida
                        </p>
                        </div>
                    </div>





                    <div class="column is-6">
                        <div class="field">
                        <label class="label">Fecha Examen Profesional</label>
                        <div class="control">
                            <input 
                            class="input" 
                            type="date" 
                            formControlName="fechaExamenProfesional">
                        </div>
                        </div>
                    </div>
                    <div class="column is-6">
                        <div class="field">
                        <label class="label">Fecha Exención Examen Profesional</label>
                        <div class="control">
                            <input 
                            class="input" 
                            type="date" 
                            formControlName="fechaExencionExamenProfesional">
                        </div>
                        </div>
                    </div>
                    <div class="column is-6">
                        <div class="field">
                        <label class="label">ID Fundamento Legal Servicio Social</label>
                        <div class="control">
                            <div class="select is-fullwidth">
                            <select 
                                formControlName="idFundamentoLegalServicioSocial"
                                (change)="onFundamentoLegalChange($event)"
                                [class.is-danger]="isFieldInvalid('idFundamentoLegalServicioSocial')">
                                <option value="">Seleccione una opción</option>
                                <option *ngFor="let fundamento of fundamentosLegales" [value]="fundamento.id">
                                {{ fundamento.id }} - {{ fundamento.texto }}
                                </option>
                            </select>
                            </div>
                        </div>
                        <p *ngIf="isFieldInvalid('idFundamentoLegalServicioSocial')" class="help is-danger">
                            Fundamento legal requerido
                        </p>
                        </div>
                    </div>
                    <div class="column is-6">
                        <div class="field">
                        <label class="label">Fundamento Legal Servicio Social</label>
                        <div class="control">
                            <input 
                            class="input" 
                            type="text" 
                            formControlName="fundamentoLegalServicioSocial"
                            readonly
                            [class.is-danger]="isFieldInvalid('fundamentoLegalServicioSocial')">
                        </div>
                        <p *ngIf="isFieldInvalid('fundamentoLegalServicioSocial')" class="help is-danger">
                            Fundamento legal requerido
                        </p>
                        </div>
                    </div>
                    <div class="column is-6">
                        <div class="field">
                        <label class="label">ID Entidad Federativa Expedición</label>
                        <div class="control">
                            <div class="select is-fullwidth">
                            <select 
                                formControlName="idEntidadFederativaExpedicion"
                                (change)="onEntidadFederativaChange($event)"
                                [class.is-danger]="isFieldInvalid('idEntidadFederativaExpedicion')">
                                <option value="">Seleccione una entidad</option>
                                <option *ngFor="let entidad of entidadesFederativas" [value]="entidad.id">
                                {{ entidad.id }} - {{ entidad.nombre }}
                                </option>
                            </select>
                            </div>
                        </div>
                        <p *ngIf="isFieldInvalid('idEntidadFederativaExpedicion')" class="help is-danger">
                            Entidad federativa requerida
                        </p>
                        </div>
                    </div>
                    <div class="column is-6">
                        <div class="field">
                        <label class="label">Entidad Federativa Expedición</label>
                        <div class="control">
                            <input 
                            class="input" 
                            type="text" 
                            formControlName="entidadFederativaExpedicion"
                            readonly
                            [class.is-danger]="isFieldInvalid('entidadFederativaExpedicion')">
                        </div>
                        <p *ngIf="isFieldInvalid('entidadFederativaExpedicion')" class="help is-danger">
                            Entidad federativa requerida
                        </p>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
                
                <!-- Card: Antecedente -->
                <div class="card mb-4">
                <div class="card-header">
                    <h2 class="card-header-title">Antecedente</h2>
                    <span class="icon is-medium" [class.has-text-danger]="!isCardValid('antecedente')" [class.has-text-success]="isCardValid('antecedente')">
                      <i class="fas fa-lg" [class.fa-exclamation-triangle]="!isCardValid('antecedente')" [class.fa-check-circle]="isCardValid('antecedente')"></i>
                    </span>
                </div>
                <div class="card-content">
                    <div class="columns is-multiline">

                    <div class="column is-3">
                        <div class="field">
                            <label class="label">Número Cédula</label>
                            <div class="control">
                                <input 
                                class="input" 
                                type="text" 
                                formControlName="noCedula">
                            </div>
                        </div>
                    </div>

                    <div class="column is-9">
                        <div class="field">
                        <label class="label">Institución Procedencia</label>
                        <div class="control">
                            <input 
                            class="input" 
                            type="text" 
                            formControlName="institucionProcedencia"
                            [class.is-danger]="isFieldInvalid('institucionProcedencia')">
                        </div>
                        </div>
                    </div>

                    <div class="column is-6">
                        <div class="field">
                        <label class="label">ID Tipo Estudio Antecedente</label>
                        <div class="control">
                            <div class="select is-fullwidth">
                            <select 
                                formControlName="idTipoEstudioAntecedente"
                                (change)="onTipoEstudioAntecedenteChange($event)"
                                [class.is-danger]="isFieldInvalid('idTipoEstudioAntecedente')">
                                <option value="">Seleccione un tipo de estudio</option>
                                <option *ngFor="let tipoEstudio of tiposEstudioAntecedente" [value]="tipoEstudio.id">
                                {{ tipoEstudio.id }} - {{ tipoEstudio.nombre }}
                                </option>
                            </select>
                            </div>
                        </div>
                        <p *ngIf="isFieldInvalid('idTipoEstudioAntecedente')" class="help is-danger">
                            Tipo de estudio antecedente requerido
                        </p>
                        </div>
                    </div>
                    <div class="column is-6">
                        <div class="field">
                        <label class="label">Tipo Estudio Antecedente</label>
                        <div class="control">
                            <input 
                            class="input" 
                            type="text" 
                            formControlName="tipoEstudioAntecedente"
                            readonly
                            [class.is-danger]="isFieldInvalid('tipoEstudioAntecedente')">
                        </div>
                        <p *ngIf="isFieldInvalid('tipoEstudioAntecedente')" class="help is-danger">
                            Tipo de estudio antecedente requerido
                        </p>
                        </div>
                    </div>
                    <div class="column is-6">
                        <div class="field">
                        <label class="label">ID Entidad Federativa Antecedente</label>
                        <div class="control">
                            <div class="select is-fullwidth">
                            <select 
                                formControlName="idEntidadFederativaAntecedente"
                                (change)="onEntidadFederativaAntecedenteChange($event)"
                                [class.is-danger]="isFieldInvalid('idEntidadFederativaAntecedente')">
                                <option value="">Seleccione una entidad</option>
                                <option *ngFor="let entidad of entidadesFederativas" [value]="entidad.id">
                                {{ entidad.id }} - {{ entidad.nombre }}
                                </option>
                            </select>
                            </div>
                        </div>
                        <p *ngIf="isFieldInvalid('idEntidadFederativaAntecedente')" class="help is-danger">
                            Entidad federativa antecedente requerida
                        </p>
                        </div>
                    </div>
                    <div class="column is-6">
                        <div class="field">
                        <label class="label">Entidad Federativa Antecedente</label>
                        <div class="control">
                            <input 
                            class="input" 
                            type="text" 
                            formControlName="entidadFederativaAntecedente"
                            readonly
                            [class.is-danger]="isFieldInvalid('entidadFederativaAntecedente')">
                        </div>
                        <p *ngIf="isFieldInvalid('entidadFederativaAntecedente')" class="help is-danger">
                            Entidad federativa antecedente requerida
                        </p>
                        </div>
                    </div>
                    <div class="column is-6">
                        <div class="field">
                        <label class="label">Fecha Inicio Antecedente</label>
                        <div class="control">
                            <input 
                            class="input" 
                            type="date" 
                            formControlName="fechaInicioAntecedente">
                        </div>
                        </div>
                    </div>
                    <div class="column is-6">
                        <div class="field">
                        <label class="label">Fecha Terminación Antecedente *</label>
                        <div class="control">
                            <input 
                            class="input" 
                            type="date" 
                            formControlName="fechaTerminacionAntecedente"
                            [class.is-danger]="isFieldInvalid('fechaTerminacionAntecedente')">
                        </div>
                        </div>
                    </div>

                    
                    </div>
                </div>
                </div>




                                <!-- Card: FirmaResponsable -->
                <div class="card mb-4">
                <div class="card-header">
                    <h2 class="card-header-title">Firma del Responsable</h2>
                    <span class="icon is-medium" [class.has-text-danger]="!isCardValid('firmaResponsable')" [class.has-text-success]="isCardValid('firmaResponsable')">
                      <i class="fas fa-lg" [class.fa-exclamation-triangle]="!isCardValid('firmaResponsable')" [class.fa-check-circle]="isCardValid('firmaResponsable')"></i>
                    </span>
                </div>
                <div class="card-content">
                    <div class="columns is-multiline">
                    <!-- Select de firmantes -->
                    <div class="column is-12">
                        <div class="field">
                            <label class="label">Seleccionar Firmante</label>
                            <div class="control">
                            <div class="select is-fullwidth">
                                <select 
                                formControlName="firmantes_titulos_id"
                                (change)="onFirmanteTituloChange($event)"
                                [class.is-danger]="isFieldInvalid('firmantes_titulos_id')"
                                [disabled]="isLoading">
                                <option value="">Seleccione un firmante</option>
                                <option *ngFor="let firmante of firmantesTitulos" [value]="firmante.id">
                                    {{ firmante.abrTitulo }} {{ firmante.nombre }} {{ firmante.primerApellido }} {{ firmante.segundoApellido }} [ {{ firmante.curp }} ]
                                </option>
                                </select>
                            </div>
                            </div>
                            <p *ngIf="isFieldInvalid('firmantes_titulos_id')" class="help is-danger">
                            Firmante requerido
                            </p>
                            <p *ngIf="isLoading" class="help is-info">
                            Cargando firmantes...
                            </p>
                        </div>
                    </div>

                    <div class="column is-2">
                        <div class="field">
                            <label class="label">Abreviatura Título</label>
                            <div class="control">
                                <input 
                                class="input" 
                                type="text" 
                                formControlName="abrTitulo"
                                readonly
                                [class.is-danger]="isFieldInvalid('abrTitulo')">
                            </div>
                        </div>
                    </div>

                    <div class="column is-4">
                        <div class="field">
                        <label class="label">Nombre</label>
                        <div class="control">
                            <input 
                            class="input" 
                            type="text" 
                            formControlName="nombreResponsable"
                            readonly
                            [class.is-danger]="isFieldInvalid('nombreResponsable')">
                        </div>
                        </div>
                    </div>

                    <div class="column is-3">
                        <div class="field">
                        <label class="label">Primer Apellido</label>
                        <div class="control">
                            <input 
                            class="input" 
                            type="text" 
                            formControlName="primerApellidoResponsable"
                            readonly
                            [class.is-danger]="isFieldInvalid('primerApellidoResponsable')">
                        </div>
                        </div>
                    </div>
                    <div class="column is-3">
                        <div class="field">
                        <label class="label">Segundo Apellido</label>
                        <div class="control">
                            <input 
                            class="input" 
                            type="text" 
                            formControlName="segundoApellidoResponsable"
                            readonly
                            [class.is-danger]="isFieldInvalid('segundoApellidoResponsable')">
                        </div>
                        </div>
                    </div>
                    <div class="column is-6">
                        <div class="field">
                        <label class="label">CURP Responsable</label>
                        <div class="control">
                            <input 
                            class="input" 
                            type="text" 
                            formControlName="curpResponsable"
                            readonly
                            [class.is-danger]="isFieldInvalid('curpResponsable')">
                        </div>
                        </div>
                    </div>

                    <div class="column is-3">
                        <div class="field">
                        <label class="label">ID Cargo</label>
                        <div class="control">
                            <div class="select is-fullwidth">
                            <select 
                                formControlName="idCargo"
                                (change)="onCargoChange($event)"
                                [class.is-danger]="isFieldInvalid('idCargo')"
                                readonly>
                                <option value="">Seleccione un cargo</option>
                                <option *ngFor="let cargo of cargos" [value]="cargo.id">
                                {{ cargo.id }} - {{ cargo.nombre }}
                                </option>
                            </select>
                            </div>
                        </div>
                        <p *ngIf="isFieldInvalid('idCargo')" class="help is-danger">
                            Cargo requerido
                        </p>
                        </div>
                    </div>

                    <div class="column is-3">
                        <div class="field">
                        <label class="label">Cargo</label>
                        <div class="control">
                            <input 
                            class="input" 
                            type="text" 
                            formControlName="cargo"
                            readonly
                            [class.is-danger]="isFieldInvalid('cargo')">
                        </div>
                        <p *ngIf="isFieldInvalid('cargo')" class="help is-danger">
                            Cargo requerido
                        </p>
                        </div>
                    </div>

                    

                    </div>
                </div>
                </div>

                <!-- Card: FirmaResponsable2 -->
                <div class="card mb-4">
                <div class="card-header">
                    <h2 class="card-header-title">Firma del Responsable 2</h2>
                    <span class="icon is-medium" [class.has-text-danger]="!isCardValid('firmaResponsable2')" [class.has-text-success]="isCardValid('firmaResponsable2')">
                      <i class="fas fa-lg" [class.fa-exclamation-triangle]="!isCardValid('firmaResponsable2')" [class.fa-check-circle]="isCardValid('firmaResponsable2')"></i>
                    </span>
                </div>
                <div class="card-content">
                    <div class="columns is-multiline">
                    <!-- Select de firmantes -->
                    <div class="column is-12">
                        <div class="field">
                            <label class="label">Seleccionar Firmante</label>
                            <div class="control">
                            <div class="select is-fullwidth">
                                <select 
                                formControlName="firmantes_titulos_id2"
                                (change)="onFirmanteTituloChange2($event)"
                                [class.is-danger]="isFieldInvalid2('firmantes_titulos_id2')"
                                [disabled]="isLoading">
                                <option value="">Seleccione un firmante</option>
                                <option *ngFor="let firmante of firmantesTitulos" [value]="firmante.id">
                                    {{ firmante.abrTitulo }} {{ firmante.nombre }} {{ firmante.primerApellido }} {{ firmante.segundoApellido }} [ {{ firmante.curp }} ]
                                </option>
                                </select>
                            </div>
                            </div>
                            <p *ngIf="isFieldInvalid2('firmantes_titulos_id2')" class="help is-danger">
                            Firmante requerido
                            </p>
                            <p *ngIf="isLoading" class="help is-info">
                            Cargando firmantes...
                            </p>
                        </div>
                    </div>

                    <div class="column is-2">
                        <div class="field">
                            <label class="label">Abreviatura Título</label>
                            <div class="control">
                                <input 
                                class="input" 
                                type="text" 
                                formControlName="abrTitulo2"
                                readonly
                                [class.is-danger]="isFieldInvalid2('abrTitulo2')">
                            </div>
                        </div>
                    </div>

                    <div class="column is-4">
                        <div class="field">
                        <label class="label">Nombre</label>
                        <div class="control">
                            <input 
                            class="input" 
                            type="text" 
                            formControlName="nombreResponsable2"
                            readonly
                            [class.is-danger]="isFieldInvalid2('nombreResponsable2')">
                        </div>
                        </div>
                    </div>
                    <div class="column is-3">
                        <div class="field">
                        <label class="label">Primer Apellido</label>
                        <div class="control">
                            <input 
                            class="input" 
                            type="text" 
                            formControlName="primerApellidoResponsable2"
                            readonly
                            [class.is-danger]="isFieldInvalid2('primerApellidoResponsable2')">
                        </div>
                        </div>
                    </div>
                    <div class="column is-3">
                        <div class="field">
                        <label class="label">Segundo Apellido</label>
                        <div class="control">
                            <input 
                            class="input" 
                            type="text" 
                            formControlName="segundoApellidoResponsable2"
                            readonly
                            [class.is-danger]="isFieldInvalid2('segundoApellidoResponsable2')">
                        </div>
                        </div>
                    </div>
                    <div class="column is-6">
                        <div class="field">
                        <label class="label">CURP Responsable</label>
                        <div class="control">
                            <input 
                            class="input" 
                            type="text" 
                            formControlName="curpResponsable2"
                            readonly
                            [class.is-danger]="isFieldInvalid2('curpResponsable2')">
                        </div>
                        </div>
                    </div>
                    <div class="column is-3">
                        <div class="field">
                        <label class="label">ID Cargo</label>
                        <div class="control">
                            <div class="select is-fullwidth">
                            <select 
                                formControlName="idCargo2"
                                (change)="onCargoChange2($event)"
                                [class.is-danger]="isFieldInvalid2('idCargo2')"
                                readonly>
                                <option value="">Seleccione un cargo</option>
                                <option *ngFor="let cargo of cargos" [value]="cargo.id">
                                {{ cargo.id }} - {{ cargo.nombre }}
                                </option>
                            </select>
                            </div>
                        </div>
                        <p *ngIf="isFieldInvalid2('idCargo2')" class="help is-danger">
                            Cargo requerido
                        </p>
                        </div>
                    </div>
                    <div class="column is-3">
                        <div class="field">
                        <label class="label">Cargo</label>
                        <div class="control">
                            <input 
                            class="input" 
                            type="text" 
                            formControlName="cargo2"
                            readonly
                            [class.is-danger]="isFieldInvalid2('cargo2')">
                        </div>
                        <p *ngIf="isFieldInvalid2('cargo2')" class="help is-danger">
                            Cargo requerido
                        </p>
                        </div>
                    </div>

                    
                    </div>
                </div>
                </div>


                <div class="mb-6"></div>

                <!-- Botón guardar inferior -->
                <!--<div class="level">
                <div class="level-right">
                    <button 
                    class="button is-primary is-large" 
                    [class.is-loading]="isLoading"
                    (click)="onSubmit()"
                    type="button"
                    [disabled]="isLoading">
                    <span class="icon">
                        <i class="fas fa-save"></i>
                    </span>
                    <span>Guardar Trámite</span>
                    </button>
                </div>
                </div>-->


            </form>
            </div>
        </div>
    </div>




    <!-- Modal de Profesionista -->

      <!-- Modal de Profesionista -->
  <div class="modal" [class.is-active]="showProfesionistaModal">
    <div class="modal-background"></div>
    <div class="modal-card" style="width: 80%; max-width: 900px;">
      <header class="modal-card-head">
        <p class="modal-card-title">Profesionista</p>
        <button class="delete" aria-label="close" (click)="cerrarModalProfesionista()"></button>
      </header>
      <section class="modal-card-body">
        <!-- Tabla de resultados -->
        <div class="table-container" style="max-height: 400px; overflow-y: auto;">
          <table class="table is-fullwidth is-striped is-hoverable">
            <thead style="position: sticky; top: 0; background: white; z-index: 1;">
              <tr>
                <th>MATRICULA</th>
                <th>NOMBRE</th>
                <th>CARRERA</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let profesionista of profesionistasResultados" 
                  (click)="asignarProfesionista(profesionista)"
                  style="cursor: pointer;">
                <td>{{ profesionista.matricula || 'N/A' }}</td>
                <td>
                  {{ profesionista.nombre || '' }} 
                  {{ profesionista.apellido_paterno || '' }} 
                  {{ profesionista.apellido_materno || '' }}
                </td>
                <td>{{ profesionista.carreras?.nombre || 'N/A' }}</td>
              </tr>
            </tbody>
          </table>
          <div *ngIf="profesionistasResultados.length === 0 && !isLoading" class="has-text-centered p-4">
            <p class="has-text-grey">No se encontraron resultados</p>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <button class="button" (click)="cerrarModalProfesionista()">Cancelar</button>
      </footer>
    </div>
  </div>


<br>







</div>
